var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("img", {
            staticClass: "profile-photo",
            attrs: { src: _vm.picture }
          }),
          _vm._v(" "),
          _vm.isUploadingPicture
            ? _c("span", [_vm._v("Aguarde...")])
            : _c(
                "a",
                {
                  staticClass: "change-photo",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.selectPhoto()
                    }
                  }
                },
                [_vm._v("Mudar foto")]
              ),
          _vm._v(" "),
          _c("input", {
            ref: "uploadBtn",
            staticClass: "input-photo",
            attrs: { type: "file" },
            on: { change: _vm.uploadPhoto }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "profile-data" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Nome completo")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.fullname,
                      expression: "fullname"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    name: "fullname",
                    placeholder: "Informe seu nome completo"
                  },
                  domProps: { value: _vm.fullname },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.fullname = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("E-mail")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "email",
                    name: "email",
                    placeholder: "Informe seu email"
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.user && _vm.user.profile != "ong"
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "form-group col-sm" }, [
                    _c("label", [_vm._v("CPF")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "###.###.###-##",
                          expression: "'###.###.###-##'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cpf,
                          expression: "cpf"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "cpf",
                        placeholder: "Informe seu CPF"
                      },
                      domProps: { value: _vm.cpf },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.cpf = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.user && _vm.user.profile == "ong"
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "form-group col-sm" }, [
                    _c("label", [_vm._v("CNPJ")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "##.###.###/####-##",
                          expression: "'##.###.###/####-##'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.cnpj,
                          expression: "cnpj"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "cnpj",
                        placeholder: "Informe seu CNPJ"
                      },
                      domProps: { value: _vm.cnpj },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.cnpj = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Telefone fixo")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "(##) ####-####",
                      expression: "'(##) ####-####'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone,
                      expression: "phone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "phone",
                    name: "phone",
                    placeholder: "(11) 9999-9999"
                  },
                  domProps: { value: _vm.phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Telefone móvel")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "(##) #####-####",
                      expression: "'(##) #####-####'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.celphone,
                      expression: "celphone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "phone",
                    name: "celphone",
                    placeholder: "(11) 99999-9999"
                  },
                  domProps: { value: _vm.celphone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.celphone = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Endereço")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.address,
                      expression: "address"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", name: "address", placeholder: "" },
                  domProps: { value: _vm.address },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.address = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Bairro")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hood,
                      expression: "hood"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", name: "hood", placeholder: "" },
                  domProps: { value: _vm.hood },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.hood = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Cidade")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.city,
                      expression: "city"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", name: "city", placeholder: "" },
                  domProps: { value: _vm.city },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.city = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Estado")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.province,
                      expression: "province"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", name: "province", placeholder: "" },
                  domProps: { value: _vm.province },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.province = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("CEP")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "##.###-###",
                      expression: "'##.###-###'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cep,
                      expression: "cep"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", name: "cep", placeholder: "" },
                  domProps: { value: _vm.cep },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.cep = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c(
            "div",
            { staticClass: "profile-data" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Categorias de ONGS preferidas" } },
                [
                  _c(
                    "b-form-checkbox-group",
                    {
                      attrs: {
                        id: "checkbox-group-2",
                        name: "flavour-2",
                        stacked: ""
                      },
                      model: {
                        value: _vm.selectedCategories,
                        callback: function($$v) {
                          _vm.selectedCategories = $$v
                        },
                        expression: "selectedCategories"
                      }
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "animais" } },
                        [_vm._v("Animais")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "criancas" } },
                        [_vm._v("Crianças")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "cultura" } },
                        [_vm._v("Cultura")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "educacao" } },
                        [_vm._v("Educação")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "esportes" } },
                        [_vm._v("Esportes")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "emergencia" } },
                        [_vm._v("Emergências")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "idosos" } },
                        [_vm._v("Idosos")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "religiao" } },
                        [_vm._v("Religião")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "mulher" } },
                        [_vm._v("Mulheres")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "natureza" } },
                        [_vm._v("Natureza")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "deficientes" } },
                        [_vm._v("Pessoas com Deficiência")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "saude" } },
                        [_vm._v("Saúde")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        { attrs: { size: "lg", value: "social" } },
                        [_vm._v("Social")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { label: "Categorias de lojas preferidas" } },
                [
                  _c(
                    "b-form-checkbox-group",
                    {
                      attrs: {
                        id: "checkbox-group-2",
                        name: "flavour-2",
                        stacked: ""
                      },
                      model: {
                        value: _vm.selectedStoreCategories,
                        callback: function($$v) {
                          _vm.selectedStoreCategories = $$v
                        },
                        expression: "selectedStoreCategories"
                      }
                    },
                    _vm._l(_vm.storeCategories, function(category) {
                      return _c(
                        "b-form-checkbox",
                        {
                          key: category.categoryId,
                          attrs: { size: "lg", value: category.categoryId }
                        },
                        [_vm._v(_vm._s(category.categoryName))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c(
              "b-form-group",
              [
                _c(
                  "b-form-radio-group",
                  {
                    attrs: {
                      id: "checkbox-group-7",
                      name: "flavour-3",
                      stacked: ""
                    },
                    model: {
                      value: _vm.selectedHability,
                      callback: function($$v) {
                        _vm.selectedHability = $$v
                      },
                      expression: "selectedHability"
                    }
                  },
                  _vm._l(_vm.arrHabilitiesWithMessages, function(c, k) {
                    return _c(
                      "b-form-radio",
                      { key: k, attrs: { size: "lg", value: c.hability } },
                      [_vm._v(_vm._s(c.message))]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "profile-data" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Senha atual")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "password",
                    name: "password",
                    placeholder: ""
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Nova senha")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newPassword,
                      expression: "newPassword"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "password",
                    name: "newPassword",
                    placeholder: ""
                  },
                  domProps: { value: _vm.newPassword },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newPassword = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-sm" }, [
                _c("label", [_vm._v("Confirmar nova senha")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newPasswordConfirm,
                      expression: "newPasswordConfirm"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "password",
                    name: "newPasswordConfirm",
                    placeholder: ""
                  },
                  domProps: { value: _vm.newPasswordConfirm },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newPasswordConfirm = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _vm.showMsg
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.msg) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSuccessMsg
            ? _c(
                "div",
                {
                  staticClass:
                    "alert alert-success alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n        " + _vm._s(_vm.successMsg) + "\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMessage()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn submit",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.save()
                }
              }
            },
            [_vm._v("Salvar Alterações")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", title: "Selecione sua Habilidade" },
          model: {
            value: _vm.showHabilityModal,
            callback: function($$v) {
              _vm.showHabilityModal = $$v
            },
            expression: "showHabilityModal"
          }
        },
        [
          _c("p", [
            _vm._v(
              "\n      A Click2giv é uma plataforma que tem por objetivo aproximar pessoas, conectar aqueles que desejam contribuir, com aqueles que necessitam de contribuição. "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n      Agora você pode contribuir com uma Organização Social através de algum conhecimento que você tenha, alguma habilidade, especialização, e assim ajudar a\n      transformar a vida de milhares de pessoas. "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n      Escolha na lista abaixo as habilidades que você possui e que gostaria de disponibilizar para uma Organização Social. Identificaremos uma ONG que necessita\n      deste apoio e colocaremos vocês em contato.\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c(
                "b-form-radio-group",
                {
                  attrs: {
                    id: "checkbox-group-2",
                    name: "flavour-2",
                    stacked: ""
                  },
                  model: {
                    value: _vm.selectedHability,
                    callback: function($$v) {
                      _vm.selectedHability = $$v
                    },
                    expression: "selectedHability"
                  }
                },
                _vm._l(_vm.arrHabilitiesWithMessages, function(c, k) {
                  return _c(
                    "b-form-radio",
                    { key: k, attrs: { size: "lg", value: c.hability } },
                    [_vm._v(_vm._s(c.message))]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Foto")]),
      _vm._v(" "),
      _c("span", [_vm._v("Adicione uma foto sua.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Seus dados")]),
      _vm._v(" "),
      _c("span", [_vm._v("Complete com seus dados pessoais.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Preferências")]),
      _vm._v(" "),
      _c("span", [_vm._v("Defina as suas preferências na plataforma.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Habilidade")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Informe uma habilidade que você possui e que possa ajudar nossos projeto sociais."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("h4", [_vm._v("Senha")]),
      _vm._v(" "),
      _c("span", [_vm._v("Atualize sua senha e mantenha sua conta segura.")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bf34f5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bf34f5f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/FormProfile.vue
// module id = null
// module chunks = 